import React from "react";
export interface IProps {
    courseNo: string;
    courseSeq: string;
    weekTimeId: string;
}
export const ScoreContext = React.createContext<IProps>({
    courseNo: "",
    courseSeq: "",
    weekTimeId: ""
});
